import { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebar } from '../redux/slices/SliderSlice';

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { email, password } = formData;
  const dispatch = useDispatch();
  const {login} = useSelector((state)=>state.sidebar);
  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}auth/login`, { email, password });
      const { token } = response.data.user;
      
      // Save the token and user in localStorage
      localStorage.setItem('userToken', token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      const udata = JSON.parse(localStorage.getItem('user'));
      // Set admin status based on email
     

      
        if(udata.email == 'Adminshreejewels@gmail.com' || udata.email == 'adminshreejewels@gmail.com'  ){
          localStorage.setItem('admin', true);
        }

      // Dispatch Redux action
      dispatch(setSidebar(true));

    
      // Navigate to the home page
      navigate('/home');
    } catch (error) {
      console.error("Login Error: ", error.response ? error.response.data : error.message);
      setError('Invalid email or password. Please try again.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleOnSubmit}
        className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">ShreeJewels</h2>
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <label className="w-full">
          <p className="mb-1 text-sm text-gray-700">
            Email Address <sup className="text-red-500">*</sup>
          </p>
          <input
            required
            type="text"
            name="email"
            value={email}
            onChange={handleOnChange}
            placeholder="Enter email address"
            className="form-style w-full border rounded-lg p-2"
          />
        </label>
        <label className="relative w-full mt-4">
          <p className="mb-1 text-sm text-gray-700">
            Password <sup className="text-red-500">*</sup>
          </p>
          <input
            required
            type={showPassword ? 'text' : 'password'}
            name="password"
            value={password}
            onChange={handleOnChange}
            placeholder="Enter Password"
            className="form-style w-full border rounded-lg p-2 pr-10"
          />
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute right-3 top-[65px] z-10 cursor-pointer"
          >
            {showPassword ? (
              <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
            ) : (
              <AiOutlineEye fontSize={24} fill="#AFB2BF" />
            )}
          </span>
        </label>
        <button
          type="submit"
          className="mt-6 w-full bg-yellow-500 text-white py-2 rounded-lg"
        >
          Sign In
        </button>
      </form>
    </div>
  );
}

export default Login;
